import React, { useEffect, useState } from "react";
import styled from "styled-components";

// MOBILE
const TestimonialContainer = styled.div`
    position: relative;
    max-width: 600px; /* Adjust based on your requirements */
`;

const TestimonialImage = styled.img`
    width: 100%;
    display: block;
    /* margin-bottom: 20vh; */

    @media screen and (min-width: 380px) and (max-width: 700px) {
        margin-bottom: 10vh;
    }

    @media screen and (max-width: 379px) {
        margin-bottom: 17vh;
    }
`;

const TestimonialText = styled.div`
    position: absolute;
    bottom: -10vh;
    left: 10px;
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    width: calc(100% - 20px); /* Padding adjustment */
    box-sizing: border-box;
    box-shadow: 0px 8px 16px 0px rgba(145, 158, 171, 0.16);
    filter: drop-shadow(0px 8px 16px rgba(145, 158, 171, 0.16));

    @media screen and (max-width: 375px) {
        bottom: -18vh;
    }
`;

const TestimonialQuote = styled.p`
    font-style: italic;
    color: #333; /* Adjust the color as needed */
    margin-bottom: 10px;

    color: var(--Dark-green, #154549);
    text-align: center;
    font-family: "Source Sans Pro";
    /* font-size: ${(props) => (props.desk ? "19px" : "17px")}; */
    font-style: italic;
    font-weight: 400;
    line-height: 147%;

    font-size: calc(16px + (19 - 16) * ((100vw - 360px) / (1440 - 360)));
`;

const TestimonailProfile = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    top: -30px;
    left: calc(50% - 30px);

    background-color: #fff;
    border-radius: 50px;
    padding: 5px;
    width: 60px;
    height: 60px;
`;

const ProfilePicture = styled.img`
    width: 50px; /* Adjust the size as needed */
    height: 50px;
    border-radius: 50%;
    margin-right: 10px;
`;

const ProfileName = styled.p`
    margin-top: ${(props) => (props.desk ? "15px" : "10px")};
    margin-bottom: 5px;
    text-align: center;
    font-size: calc(22px + (23 - 22) * ((100vw - 360px) / (1440 - 360)));

    color: #16494d;
    text-align: center;
    font-family: "Source Sans Pro Semibold";
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 23.4px */
`;

const CustomImageMobile = ({
    imageBig,
    imageSmall,
    name,
    text,
    country,
    countryFlag,
}) => {
    return (
        <TestimonialContainer>
            <TestimonialImage src={imageBig} />
            <TestimonialText>
                <TestimonailProfile>
                    <ProfilePicture src={imageSmall} />
                </TestimonailProfile>
                <ProfileName>{name}</ProfileName>
                <FlagDiv>
                    <img
                        src={`/images/languages/${countryFlag}.svg`}
                        alt={"france"}
                        className="flag"
                    />
                    <Country>{country}</Country>
                </FlagDiv>
                <TestimonialQuote>{text}</TestimonialQuote>
            </TestimonialText>
        </TestimonialContainer>
    );
};

// DESKTOP
const Wrapper = styled.div`
    position: relative;
    max-width: 500px;
    display: flex;
    margin-left: 20px;
`;

const ImageContainer = styled.div`
    flex: 1;
    padding: 10px;
    text-align: end;
    margin-bottom: 10vh;
    margin-left: 20px;
    img {
        width: 100%;
    }
`;

const ContentContainer = styled.div`
    flex: 2;
    position: absolute;
    left: -50px;
    bottom: 10px;
    max-width: 380px;
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    width: calc(100% - 20px); /* Padding adjustment */
    box-sizing: border-box;
    box-shadow: 0px 8px 16px 0px rgba(145, 158, 171, 0.16);
    filter: drop-shadow(0px 8px 16px rgba(145, 158, 171, 0.16));

    @media screen and (max-width: 1024px) {
        left: -30px;
        width: calc(75% - 20px);
    }
`;

const Country = styled.h5`
    color: #000;
    font-family: "Open Sans", sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 140%;

    @media screen and (max-width: 600px) {
        font-size: 16px;
    }
`;

const FlagDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;

    img {
        width: 29px;
        height: 19px;
        margin-right: 6px;
    }
`;

// Your React component
const CustomImageDesk = ({
    imageBig,
    imageSmall,
    name,
    text,
    country,
    countryFlag,
}) => {
    return (
        <Wrapper>
            <ImageContainer>
                <img src={imageBig} />
            </ImageContainer>
            <ContentContainer>
                <TestimonailProfile>
                    <ProfilePicture src={imageSmall} />
                </TestimonailProfile>
                <ProfileName desk>{name}</ProfileName>
                <FlagDiv>
                    <img
                        src={`/images/languages/${countryFlag}.svg`}
                        alt={"france"}
                        className="flag"
                    />
                    <Country>{country}</Country>
                </FlagDiv>
                <TestimonialQuote desk>{text}</TestimonialQuote>
            </ContentContainer>
        </Wrapper>
    );
};

const CustomImage = ({
    imageBig,
    imageSmall,
    name,
    text,
    country,
    countryFlag,
}) => {
    const [showMobile, setShowMobile] = useState(false);

    useEffect(() => {
        window.addEventListener("resize", handleResize, false);
        handleResize();
    }, []);

    const handleResize = () => {
        if (window.innerWidth > 700) {
            setShowMobile(false);
        }

        if (window.innerWidth <= 700) {
            setShowMobile(true);
        }
    };

    return (
        <>
            {showMobile && (
                <CustomImageMobile
                    imageBig={imageBig}
                    imageSmall={imageSmall}
                    name={name}
                    text={text}
                    country={country}
                    countryFlag={countryFlag}
                />
            )}
            {!showMobile && (
                <CustomImageDesk
                    imageBig={imageBig}
                    imageSmall={imageSmall}
                    name={name}
                    text={text}
                    country={country}
                    countryFlag={countryFlag}
                />
            )}
        </>
    );
};

export default CustomImage;
